import { render, staticRenderFns } from "./AfflictionSightingFilesTable.vue?vue&type=template&id=b3f3641e"
import script from "./AfflictionSightingFilesTable.vue?vue&type=script&lang=js"
export * from "./AfflictionSightingFilesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports